import Vue from "vue";
import OrderApi from "../../../../services/api/orderApi.js";
import MiscApi from "../../../../services/api/misc.js";
import { mapGetters } from "vuex";

const OrderApiService = new OrderApi(),
  MiscApiService = new MiscApi();

export default {
  data() {
    return {
      order: null,
      my_full_name: null,
    };
  },

  methods: {
    getOrder,
    scrollToSuborder,
  },

  beforeMount() {
    this.getOrder();
    MiscApiService.getMeRetailer().then((response) => {
      this.my_full_name = `${response.data.first_name} from ${response.data.store_name}`;
    });
  },

  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
};

function getOrder() {
  this.$loader.$emit("trigger", true);

  OrderApiService.getOrder(this.$route.params.orderId)
    .then(async (response) => {
      this.order = {
        ...response.data,
        suborders: response.data.suborders.map((suborder) => ({
          ...suborder,
          items: suborder.items.map((item) => ({
            ...item,
            original_fulfilled_quantity: item.fulfilled_quantity,
          })),
        })),
      };

      await Vue.nextTick();

      this.scrollToSuborder();
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function scrollToSuborder() {
  const suborderId = this.$route.query.suborderId,
    suborderElement = this.$el.querySelectorAll(`[data-suborder-id="${suborderId}"]`)[0],
    navElement = document.body.querySelectorAll("#navbar")[0];

  if (suborderElement) {
    window.scrollTo({
      top: suborderElement.offsetTop - (navElement ? navElement.clientHeight : 0) - 20,
    });
  }
}
